"use client";

import { useLanguage } from "@/i18n/LanguageContext";

const featureIcons = ["Aa", "ri-eye-line", "ri-keyboard-line", "ri-computer-line", "ri-cursor-line", "ri-smartphone-line"];

export default function FeaturesSection() {
  const { t } = useLanguage();
  const titles = t("access.featureTitles") as string[];
  const bodies = t("access.featuresList") as string[];

  return (
    <section className="bg-[#fefce8] py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-[28px] font-black text-[#064e3b] text-center mb-4">
          {t("access.h2Features")}
        </h2>
        <p className="text-[#374151] leading-[1.7] text-center max-w-3xl mx-auto mb-10">
          {t("access.featuresText")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featureIcons.map((icon, i) => (
            <div
              key={titles[i] || i}
              className="bg-white rounded-xl p-6 border border-[#047857]/20 shadow-sm"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#047857] text-white text-lg font-black mb-4">
                {icon === "Aa" ? (
                  <span className="text-base font-black">Aa</span>
                ) : (
                  <i className={icon} />
                )}
              </div>
              <h3 className="text-base font-bold text-[#064e3b] mb-2">
                {titles[i]}
              </h3>
              <p className="text-sm text-[#374151] leading-relaxed">
                {bodies[i]}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}